// extracted by mini-css-extract-plugin
export default {"host":"style_host__yqZ9a","body":"style_body__fdOmI","recipients":"style_recipients__Zl0rR","emailButton":"style_emailButton__1ibxR"};